<template lang="pug">
toggle-button(:value="is_active", @change="toggleHeatmap()", :labels="true", :sync="true")
</template>

<script>
import axios from '../../plugins/axios';

export default {
  props: {
    heatmapToken: String,
    isActive: Boolean,
  },
  data(){
    return {
      is_active: this.isActive
    }; 
  },
  methods: {
    async toggleHeatmap() {
      const originValue = this.is_active
      this.is_active = !this.is_active;
      try {
        const response = await axios.post("/api/v1/heatmaps/change_active/" + this.heatmapToken, 
        {
          token: this.heatmapToken,
          isActive: this.is_active,
        })
        
        if (response.status >= 200 && response.status < 300) {
          this.$toasted.success(response.data.message)
          await sleep(10000)
          this.$toasted.clear()
        } else {
          this.is_active = originValue
          this.$toasted.error(response.data.message)
          await sleep(10000)
          this.$toasted.clear()
        }
       } catch (error) {
        this.is_active = originValue
         if(error.response){
          const dummyEvent = {
            preventDefault: () => {}
          }
          window.users_vue_app.openModalServiceLimit(dummyEvent)
         } else {
            this.$toasted.error(response.data.message)
            await sleep(10000)
            this.$toasted.clear()
         }
       }
    },
  }
}
</script>